export const API_BASE = import.meta.env.VITE_API_URL || "";
export const BOT_INVITE_URL =
  import.meta.env.VITE_DISCORD_INVITE_URL ||
  // "https://discord.com/oauth2/authorize?client_id=1440115243136057354&permissions=395942423568&integration_type=0&scope=bot+applications.commands"; // dev
  "https://discord.com/oauth2/authorize?client_id=1424471379285114981&permissions=395942423568&integration_type=0&scope=bot+applications.commands"; // prod
// // STATUS: CLOSED (Uncomment this line below when > 95 servers)
// export const BOT_INVITE_URL = "/capacity";
